import '../../styles/components/SyncSummary.scss';

const SyncSummary = ({ summary }) => {
  if (!summary) return null;

  return (
    <div className="sync-summary">
      <h3>Sincronización completada</h3>
      <div className="sync-summary__card">
        <h4>Proveedor: {summary.provider}</h4>
        <p>
          <strong>{summary.created}</strong>
          Productos creados
        </p>
        <p>
          <strong>{summary.updated}</strong>
          Productos actualizados
        </p>
        <p>
          <strong>{summary.skipped || 0}</strong>
          Ignorados
        </p>
        <p className={summary.errors > 0 ? 'text-danger' : 'text-success'}>
          <strong>{summary.errors}</strong>
          Errores
        </p>
      </div>

      {summary.errors > 0 && (
        <div className="sync-summary__errors">
          <h5>Detalle de errores</h5>
          <ul>
            {summary.errorDetails.map((err, i) => (
              <li key={i}>
                <strong>Ref:</strong> {err.reference || 'N/A'} — {err.error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SyncSummary;
